
export const expeditionType = [
    {
      name: "Sea",
      id: "sea"
    },
    {
      name: "Air",
      id:"air"
    }
  ];